<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .feedback {
    width: utils.in_rem(344px);
    border-radius: 16px;

    background-color: colors.get(interfaceWhite);
    box-shadow: 0px 4px 20px 0px #00000014;

    > h3 {
      @include mixins.h3();
      padding: utils.in_rem(16px) utils.in_rem(24px) 0 utils.in_rem(24px);
    }

    .feedback-buttons {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);
      padding: utils.in_rem(16px);
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import FloatingUI from "@sourcewhale/shared/svelte-design-system/components/utils/FloatingUI.svelte";
  import Done from "./Done.svelte";

  import { downvoteCompanyInsights } from "../../../../api/extension";
  import {
    makeEscapeAction,
    makeWindowClick,
  } from "@sourcewhale/shared/src/svelte/utils/escapable";
  import { companyInsightsOptsStore, companyInsightsStore } from "../stores";
  import Footer from "./Footer.svelte";

  export let el;
  export let show = false;

  let floatingEl;

  let done = false;
  let feedbackJustSubmitted = false;
  let showOther = false;
  let manualReason = "";

  const submitFeedback = async (reason) => {
    const body = {
      candidateId: $companyInsightsOptsStore.obj?.candidateId,
      _id: $companyInsightsStore.id,
      reason,
    };
    await downvoteCompanyInsights(body);
    feedbackJustSubmitted = true;
    done = true;
  };

  const reasonClick = (kind) => () => {
    if (kind === "other") {
      showOther = !showOther;
      if (!showOther) manualReason = "";
    } else submitFeedback(kind);
  };

  const buttonProps = (kind) => ({
    kind: "tertiary",
    size: "small",
    style: "width: 100%;",
    onclick: reasonClick(kind),
  });

  export const close = () => {
    show = false;
    feedbackJustSubmitted = false;
    showOther = false;
    manualReason = "";
  };

  // Reset everything when the company insights store changes
  companyInsightsStore.subscribe(() => {
    done = false;
    close();
  });

  const escape = makeEscapeAction(close);

  // feedbackJustSubmitted is used to prevent the windowClick event from closing the feedback window
  // immediately after submitting feedback, because the elements used to check for a window click
  // disappear when done is set to true.
  $: windowClick = feedbackJustSubmitted
    ? () => {
        feedbackJustSubmitted = false;
      }
    : makeWindowClick(close, el, floatingEl);
</script>

<svelte:window on:click={windowClick} />

{#if show}
  <FloatingUI
    referenceEl={el}
    bind:floatingEl
    class="z-index-1"
    placement="bottom-end"
    {escape}
  >
    <div class="feedback">
      <h3>Report an issue</h3>
      {#if !done}
        <div class="feedback-buttons">
          <Button {...buttonProps("outOfDate")}>Out of date information</Button>
          <Button {...buttonProps("wrongCompany")}>Wrong company</Button>
          <Button {...buttonProps("other")}>Other</Button>
          {#if showOther}
            <TextInput
              bind:value={manualReason}
              label="Other reason"
              placeholder="Write your reason for feedback"
            />
          {/if}
        </div>
        {#if showOther}
          <Footer
            cancel={close}
            submit={() => (manualReason ? submitFeedback(manualReason) : "")}
            disabled={!manualReason}
          />
        {/if}
      {:else}
        <Done />
      {/if}
    </div>
  </FloatingUI>
{/if}
